module.exports = __webpack_public_path__ + "img/market.b84e2bc7.svg";